import { toast } from 'react-toastify';
import { config } from '../../Config';
import { v4 as uuidv4 } from 'uuid';

const UploadFiles = async (files, chatId = "default", updateFileStatus, extensionId = "default") => {
    const maxRetries = 3;
    const retryDelay = 3000;
    const url = config.generateUploadUrls
    // const dev_url = "https://dev-dbot-functions.azurewebsites.net/api/generate-upload-urls?code=9mlvnGWAfMUvojPnJ92PArYMJlo3RMKmnuUl1pn1G26hAzFuPgl0JA==";
   
    const uploadedFiles = [];

    try {
        const fileMetadata = files.map(file => ({
            fileName: file.name,
            fileType: file.type,
            chatId: chatId,
            extensionId: extensionId,
            documentId: uuidv4(),
        }));

        const requestBody = {
            chatId: chatId,
            extensionId: extensionId,
            files: fileMetadata,
        };

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to get pre-signed URLs: ${errorText}`);
        }

        const result = await response.json();

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const uploadUrl = result.files[i].uploadUrl;
            const documentId = fileMetadata[i].documentId;
            const fileUrl = uploadUrl.split("?")[0]; // Remove query params if needed

            // console.log("upload url: ", uploadUrl);
            try {
                await fetch(uploadUrl, {
                    method: 'PUT',
                    headers: {
                        'x-ms-blob-type': 'BlockBlob',
                        'Content-Type': file.type,
                        'Content-Length': file.size,
                        'x-ms-meta-chatId': chatId,
                        'x-ms-meta-documentId': documentId,
                        'x-ms-meta-extensionId': extensionId
                    },
                    body: file
                });

                updateFileStatus(file.name, 'uploaded');
                uploadedFiles.push({
                    chatId: chatId,
                    file_uri: fileUrl,
                    file_name: file.name,
                    blob_size: file.size,
                    content_type: file.type,
                    file_type: file.type,
                    creation_time: new Date().toISOString(),
                    last_modified: new Date().toISOString(),
                    expiry_time: "0001-01-01T00:00:00+00:00",
                    available: true,
                    metadata: {
                        documentId,
                        chatId
                    }
                });
            } catch (error) {
                // console.error(`Error uploading file ${file.name}:`, error);
                updateFileStatus(file.name, 'error');
                // toast.error(`Error uploading file "${file.name}": ${error.message}`);
                throw error;
            }
        }

        await retryTriggerIndexer(maxRetries, retryDelay);
        return {
            message: `${files.length} files uploaded and indexer triggered successfully.`,
            status: 200,
            uploadedFiles // Return uploaded file names and URLs
        };
    } catch (error) {
        // console.error('Error during file upload or indexer trigger:', error);
        toast.error(`Error during file upload or indexer trigger: ${error.message}`);
        throw error;
    }
};

const retryTriggerIndexer = async (maxRetries, delay) => {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const indexerResponse = await fetch(config.triggerIndexer, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (indexerResponse.ok) {
                return;
            }

            const errorText = await indexerResponse.text();
            throw new Error(errorText);
        } catch (error) {
            if (attempt === maxRetries) {
                throw new Error(`Failed to trigger indexer after ${maxRetries} attempts: ${error.message}`);
            }
            // console.warn(`Retrying indexer trigger (Attempt ${attempt}/${maxRetries})...`);
            await new Promise(resolve => setTimeout(resolve, delay));
        }
    }
};

export default UploadFiles;